export default __webpack_public_path__ + "static/media/rimpic4.e7b96cd0.jpg";